import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap5';

import useWallet from 'components/Common/Members/Hooks/useWallet';
import { PubSub } from 'aws-amplify';
import routes from 'app/routes';
import { useContext as useHomeContext } from 'components/Members/Home/Context';
import { useContext as useUsersContext } from 'components/Users/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import useIot from 'components/Common/Iot/Hooks/useIot';
import TitleAndActions from './Program/TitleAndActions';
import PlanCreditDates from './Program/PlanCreditDates';
import ProgramInfo from './Program/ProgramInfo';
import PriorityMatrixStep from './Steps/PriorityMatrixStep';
import Steps from './Steps/Index';
import Badge from './Badge';

import { useContext } from './Context';

export default function RegularProgram({ program }) {
  const [showStep, setShowStep] = useState(null);
  const wallet = useWallet();

  const matrixStep = program.attributes.steps.find((step) => step.step_type === 'matrix');

  const { actions, dispatch } = useContext();
  const homeContext = useHomeContext();
  const { state: stateUsers } = useUsersContext();

  useIot();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: program.attributes.title,
    },
  ];

  useEffect(() => {
    let sub = null;
    if (stateUsers.user) {
      sub = PubSub.subscribe(`user-${stateUsers.user.attributes.token}`).subscribe({
        next: ({ value }) => {
          if (value.type === 'step:content_generated') {
            const stepId = value.step_id.toString();
            const { data } = value;

            actions.updateStep(dispatch, stepId, data);
          }
        },
      });
    }

    return () => {
      if (sub) {
        sub.unsubscribe();
      }
    };
  }, [stateUsers.user]);

  return (
    <>
      <div className="content program-view">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <div className={showStep ? 'd-none d-lg-block' : ''}>
            <TitleAndActions program={program} />

            {program.attributes.program_category === 'coaching' && <PlanCreditDates wallet={wallet} />}

            <ProgramInfo program={program} />
          </div>

          <Row>
            <Col>
              <Steps
                steps={program.attributes.steps}
                programId={parseInt(program.id, 10)}
                showStep={showStep}
                setShowStep={setShowStep}
              />
            </Col>
          </Row>
        </section>
      </div>

      <div className={showStep ? 'd-none d-lg-block' : ''}>
        {matrixStep && (
        <div className="content">
          <section>
            <PriorityMatrixStep step={matrixStep} />
          </section>
        </div>
        )}

        <div className="content">
          <section>
            <Badge program={program} />
          </section>
        </div>
      </div>

      <Outlet />
    </>
  );
}

RegularProgram.propTypes = {
  program: PropTypes.object.isRequired,
};
